/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  function waitForElement(selector, callback) {
    const interval = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
            clearInterval(interval);
            callback(element);
        }
    }, 100); // Check every 100ms
  }

  waitForElement(".Avada-GiftCampaign__PriceDefault", (priceDefault) => {
    let priceDiscount = document.querySelector(".Avada-GiftCampaign__PriceDiscount");
    
    console.log(priceDiscount.innerText);
    console.log(priceDefault.innerText);

    if ( priceDiscount.innerText == priceDefault.innerText ) {
      priceDefault.style.display = "none";
    }
  });


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();